import Box from '@mui/material/Box'
import { ChangeEvent, FC, FocusEventHandler, memo } from 'react'
import Radio from '@mui/material/Radio'
import Typography from '@mui/material/Typography'
import Tooltip from '@mui/material/Tooltip'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'

const RadioButton: FC<{
  value?: string | number | boolean | null
  checked: boolean
  label: string
  tooltip?: string
  onChange?: (event: ChangeEvent<HTMLInputElement>, checked: boolean) => void
  onBlur?: FocusEventHandler<HTMLButtonElement>
  disabled?: boolean
}> = ({ value, checked, label, tooltip, onChange, onBlur, disabled }) => {
  return (
    <Box
      component="label"
      sx={theme => ({
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        border: `1px solid ${theme.palette.primary.main}`,
        borderRadius: 1,
        cursor: 'pointer',
        position: 'relative',
        paddingRight: 1,
        backgroundColor: '#fff',
      })}
    >
      <Box>
        <Radio
          size="small"
          value={value}
          checked={checked}
          onChange={onChange}
          onBlur={onBlur}
          disabled={disabled}
          sx={{
            '&:hover': {
              backgroundColor: 'transparent',
            },
          }}
        />
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Typography
          component={'span'}
          variant="subtitle2"
          sx={{ fontSize: 12, lineHeight: '12px' }}
        >
          {label}
        </Typography>
      </Box>
      {tooltip && (
        <Box
          sx={{
            position: 'absolute',
            top: '-8px',
            right: '-8px',
          }}
        >
          <Tooltip title={tooltip} enterTouchDelay={0} placement="top">
            <InfoOutlinedIcon
              color="primary"
              sx={{ fontSize: 16, backgroundColor: 'white', borderRadius: '50%' }}
            />
          </Tooltip>
        </Box>
      )}
    </Box>
  )
}

export default memo(RadioButton)
